import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteAssessment = {
  name: "deleteAssessment" as const,

  input: z.object({ assessmentId: zExt.objectId() }),

  output: z.object({ success: z.boolean() }),
};
